export const telefonos = [
    {    
    "area": "Dirección General de Ganadería : Tel: 771 717 8028 / 771 717 8023 ",      
},
{    
    "area": "Dirección General de la Cafeticultura : Tel: 771 717 8000  Ext. 8042 / 8050 /8052 / 8481 ",      
},
{    
    "area": "Dirección General de Silvicultura, Fruticultura, Acuacultura y del Maguey : Tel: 771 717 8000  Ext. 8041  ",      
},
{    
    "area": "Dirección General de Agricultura : Tel: 771 717 8000  Ext. 8421 / 8013  ",      
},
{    
    "area": "Dirección General de Fomento Lechero: Tel: 771 717 8000  Ext. 8612 ",      
},
{
    "area":"Despacho:       Tel: 7717178008 / 7717178007",
},


]

export const correos = [
    {
    // "area":"Correo: saderh@hidalgo.gob.mx",
},

]

export const buzon = [
    {
        nombre: 'Buzón SADERH ',
        url:'https://docs.google.com/forms/d/e/1FAIpQLSdmzqc8IrZb0SSL5Q0koSDgipzbyYVtSSt9fZNA6lpIzT3CKw/viewform?usp=header',
        icon: 'buzon.svg'
    },

]

